<script>
export default {
  props: {
    salesPerformanceData: {
      type: Object,
      default: () => null,
    },
    title: {
      type: String,
      default: () => '',
    },
    name: {
      type: String,
      default: () => '',
    },
    campaignId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      chartOptions: {},
      apexChartsBarArea: 0,
    };
  },

  mounted() {
    this.initChart();
  },

  watch: {
    salesPerformanceData: {
      handler() {
        this.initChart();
      },
      deep: true,
    },
  },

  methods: {
    initChart() {
      if (
        this.salesPerformanceData &&
        this.salesPerformanceData.labels &&
        this.salesPerformanceData.revenue &&
        this.salesPerformanceData.ordersCount
      ) {
        this.renderBarChart();

        this.$nextTick(() => {
          if (this.$refs.apexchart) {
            this.$refs.apexchart.chart.updateOptions({
              chart: { width: '100%' },
            });
          }
        });
      }
    },

    renderBarChart() {
      const revenue = this.salesPerformanceData.revenue || [];
      const orders = this.salesPerformanceData.ordersCount || [];
      const labels = this.salesPerformanceData.labels || [];

      this.chartOptions = {
        series: [
          {
            name: 'CA',
            data: revenue,
          },
          {
            name: 'Commandes',
            data: orders,
          },
        ],

        chart: {
          type: 'area',
          height: 350,
          toolbar: {
            show: false,
          },
        },

        colors: ['#1d3266', '#D4AF37'],

        stroke: {
          curve: 'smooth',
          width: [3, 3],
        },

        markers: {
          size: [0, 0],
        },

        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.9,
            opacityFrom: 0.8,
            opacityTo: 0.3,
            stops: [0, 100],
          },
        },

        dataLabels: {
          enabled: false,
        },

        xaxis: {
          categories: labels,
        },

      yaxis: [
        {
          title: {
            text: 'CA',
          },
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        {
          opposite: true,
          title: {
            text: 'Commandes',
          },
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        }
      ],

        legend: {
          show: true,
        },

        responsive: [
          {
            breakpoint: 768,
            options: {
              chart: {
                toolbar: { show: false },
              },
            },
          },
        ],
      };
    },
  },
};
</script>

<template>
  <div class="h-100">
    <apexchart
      ref="apexchart"
      :key="apexChartsBarArea"
      v-if="
        salesPerformanceData &&
        salesPerformanceData.labels &&
        salesPerformanceData.revenue &&
        salesPerformanceData.ordersCount
      "
      type="area"
      height="340"
      :options="chartOptions"
      :series="chartOptions.series"
    />

    <div
      v-else
      class="d-flex justify-content-center align-items-center text-info h-100"
      style="min-height: 340px;"
    >
      Pas de collecte de données
    </div>
  </div>
</template>